import { render, staticRenderFns } from "./myDomain.vue?vue&type=template&id=4a29bc8e&scoped=true&"
import script from "./myDomain.vue?vue&type=script&lang=js&"
export * from "./myDomain.vue?vue&type=script&lang=js&"
import style0 from "./myDomain.vue?vue&type=style&index=0&id=4a29bc8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a29bc8e",
  null
  
)

export default component.exports